import { Form as FormikForm } from 'formik';
import { FormHTMLAttributes, PropsWithChildren } from 'react';

export function Form({ children, ...props }: PropsWithChildren<FormHTMLAttributes<HTMLFormElement>>) {
  return (
    <FormikForm noValidate {...props}>
      {children}
    </FormikForm>
  );
}
